import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["expanded", "children"];
import React from 'react';
import { intrinsicComponent } from '../../utils/functions';
import Styled from './accordion-details.styles';
var AccordionDetails = intrinsicComponent(function (_ref, ref) {
  var _ref$expanded = _ref.expanded,
    expanded = _ref$expanded === void 0 ? false : _ref$expanded,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(React.Fragment, null, expanded && /*#__PURE__*/React.createElement(Styled.AccordionDetails, _extends({
    ref: ref
  }, rest), children));
});
export default AccordionDetails;